import { AgentBookingWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AgentBookingWebService.Configuration
});

export default config;
